import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './InvoicesEmptyState.styles';

export const InvoicesEmptyState = () => {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Image
        src="/images/transactions-empty.png"
        alt={t('pages.cabinet.you_dont_have_any_operations_yet')}
      />
      <S.Title>{t('pages.cabinet.you_dont_have_any_operations_yet')}</S.Title>
      <S.Subtitle>
        {t('pages.cabinet.invoices_history_will_be_displayed_here')}
      </S.Subtitle>
    </S.Container>
  );
};
